import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Cómo recibo la guía?',
    a: 'Una vez confirmado tu pago, recibirás un enlace de descarga inmediata en tu correo electrónico.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. La guía está diseñada para principiantes que quieren empezar desde cero.'
  }, {
    q: '¿Cuánto tiempo necesito?',
    a: 'El método está diseñado para completarse en 7 días dedicando unas pocas horas al día.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es 100% digital. Recibirás un archivo PDF que puedes leer desde cualquier dispositivo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 lg:px-8 bg-brand-light text-slate-900" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-22">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark" data-id="element-23">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-slate-200 rounded-2xl overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-26">
                <span className="font-bold text-lg text-slate-800" data-id="element-27">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-28" />
              </button>
              <AnimatePresence data-id="element-29">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="px-6 pb-5 text-slate-600" data-id="element-31">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}